S.stageXmas =
    {
        elements: {
            $time: null,
        },
        init()
        {
            var utcSeconds = this.elements.$time.data('time');
            var d = new Date(0);

            d.setUTCSeconds(utcSeconds);
            const strDate = d.getUTCFullYear() + '/' + (d.getUTCMonth() + 1) + '/' + d.getUTCDate() + ' ' + d.getUTCHours() + ':' + d.getUTCMinutes();

            this.elements.$time.countdown(strDate, function (event)
            {
                $(this).html(event.strftime('%Dt : %Hs : %Mm : %Ss'));
            });
        },

    }
;
